import React, { useRef, useState } from "react";
import "../style/AllStories.scss";
import { click } from "@testing-library/user-event/dist/click";
// import { MaterialIcons } from "@expo/vector-icons";

const AllStories = (props) => {
  const { stories } = props;
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(clicked ? false : true);
  };

  return (
    <div className="body-text">
      {/* 추가 Text */}
      <div className="last-text"></div>

      {/* 시리즈 모두 보기 버튼 */}
      <a href="https://www.donga.com/news/Series/70020000000430" target="_blank">
        <div className="show-series">
          시리즈 모두 보기{" "}
          <img
            className="link-to-hero-img"
            src="https://image.donga.com/policy/original/sos/sos2/images/link_to_hero.png"
            alt="링크"
          />
        </div>
      </a>

      {/* 시리즈 모두 보기 box */}
      <div className="all-stories-box">
        <div className="all-stories-title">장애, 테크로 채우다</div>
        {/*  */}
        <div
          className={
            clicked ? "all-stories show-more" : "all-stories show-less"
          }
        >
          {stories.map((story, index) => (
            <div
              className="each-story"
              style={{ opacity: index > 1 ? (clicked ? 1 : 0) : 1 }}
              key={"story" + index}
            >
              <a href={story.url} target="_blank">
                <img src={process.env.PUBLIC_URL + "/" + story.img} />
                <div className="each-story-title">{story.title}</div>
              </a>
            </div>
          ))}
        </div>

        <div className="show-more-text" onClick={handleClick}>
          {clicked ? "접기" : "모든 회차 보기"}
        </div>
      </div>
    </div>
  );
};

export default AllStories;
